module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/unzip_imgs.worker.512224c5a5a6463b746b.js");
}
